// eslint-disable-next-line
import { injectable } from "inversify";
import { TYPE, rootContainer } from '../container/root';
import { IApiResponse, IHttpService } from "../http-service";
import { IAccountModel, IAccountSetting } from '../../models/Account';

@injectable()
class AccountService {

    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async fetchList(): Promise<IAccountModel[]> {
        const res = await this.httpService.get<IApiResponse<IAccountModel[]>>(`/rms-api/user-management/accounts`);
        return res.payload;
    }

    public async loadCurrentUserProfileData(): Promise<IAccountModel> {
        const res = await this.httpService.get<IApiResponse<IAccountModel>>(`/rms-api/user/profile`);
        return res.payload;
    }

    public async updateProfile(profile: IAccountModel): Promise<IAccountModel> {
        const res = await this.httpService.put<IApiResponse<IAccountModel>>(`/rms-api/user/profile`, profile);
        return res.payload;
    }

    public async updateAccount(id: number, accountData: IAccountModel): Promise<IAccountModel> {
        const res = await this.httpService.put<IApiResponse<IAccountModel>>(`/rms-api/user-management/accounts/${id}`, accountData);
        return res.payload;
    }

    public async createAccount(accountData: IAccountModel): Promise<IAccountModel> {
        const res = await this.httpService.post<IApiResponse<IAccountModel>>(`/rms-api/user-management/accounts`, accountData);
        return res.payload;
    }

    public async updateAccountSetting(accountId:number, setting:IAccountSetting): Promise<IAccountSetting> {
        const res = await this.httpService.put<IApiResponse<IAccountSetting>>(`/rms-api/user-management/accounts/${accountId}/setting`, setting);
        return res.payload;
    }

    public async changeUserPassword(password: string, passwordConfirm: string): Promise<IApiResponse<Boolean>> {
        return await this.httpService.post(`/rms-api/user/password`, {
            'password': password,
            'password_confirm': passwordConfirm,
        });
    }

    public async changePasswordByUserId(userId: number, password: string, passwordConfirm: string): Promise<IApiResponse<Boolean>> {
        return await this.httpService.post(`/rms-api/users/${userId}/password`, {
            'password': password,
            'password_confirm': passwordConfirm,
        });
    }
}

export default AccountService;
